import { render, staticRenderFns } from "./AlterarDadosMedico.vue?vue&type=template&id=fabb4c1a"
import script from "./AlterarDadosMedico.vue?vue&type=script&lang=js"
export * from "./AlterarDadosMedico.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports